import React from 'react';
import { useDrag, useDrop } from 'react-dnd';
import {BurgerIcon} from "~/Components/Icons/Icons";


export const AdminDnDCard = ({ id, text, onClick, moveCard, findCard, selected = false, draggable = true }) => {

    const originalIndex = findCard(id).index;

    const [{ isDragging }, drag, preview] = useDrag({
        item: { type: 'card', id, originalIndex },
        collect: (monitor) => ({
            isDragging: monitor.isDragging(),
        }),
        end: (dropResult, monitor) => {
            const { id: droppedId, originalIndex } = monitor.getItem();
            const didDrop = monitor.didDrop();
            if (!didDrop) {
                moveCard(droppedId, originalIndex);
            }
        },
    });

    const [, drop] = useDrop({
        accept: 'card',
        canDrop: () => false,
        hover({ id: draggedId }) {
            if (draggedId !== id) {
                const { index: overIndex } = findCard(id);
                moveCard(draggedId, overIndex);
            }
        },
    });

    const opacity = isDragging ? 0 : 1;

    let style = {
        border: '1px solid #D7DAE5',
        marginBottom: '.5rem',
        backgroundColor: 'white',
        overflow: 'hidden'
    };

    if (selected) {
        style.border = '1px solid #EBC03F';
    }

    let burgerStyle = {
        cursor: 'move',
    };

    let textStyle = {
        padding: '0.5rem 1rem 0.5rem 0',
        cursor: 'pointer'
    };

    return (
        <div
            ref={preview}
            className="admin-dnd-card text-nowrap"
            style={{ ...style, opacity }}
            onClick={e => onClick(parseInt(id))}
        >
            {draggable ?
                <div className="dragger d-inline-block"
                    style={{...burgerStyle}}
                    ref={(node) => drag(drop(node))}
                >
                    <BurgerIcon />
                </div>
                : null
            }

            <div className="d-inline-block mr-2"
                style={{...textStyle}}
            >
                {text}
            </div>
        </div>
    );
};
